import { render } from "./MMHomeSlides.vue?vue&type=template&id=6b8cd2c6"
import script from "./MMHomeSlides.vue?vue&type=script&lang=js"
export * from "./MMHomeSlides.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__